import { render, staticRenderFns } from "./CompanyFirstVatInfoSelector.vue?vue&type=template&id=04addfdb"
import script from "./CompanyFirstVatInfoSelector.vue?vue&type=script&lang=ts"
export * from "./CompanyFirstVatInfoSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports